import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  ngOnInit(): void {
    this.captureShopifyParams();
  }

  private captureShopifyParams(): void {
    const params = new URLSearchParams(window.location.search);

    const host = params.get('host');
    const shop = params.get('shop');

    // Store immediately if present
    if (host) {
      localStorage.setItem('shopify_host', host);
    }

    if (shop) {
      localStorage.setItem('shopify_shop', shop);
    }

    // Optional: fallback check
    if (!host && !localStorage.getItem('shopify_host')) {
      console.error('⚠️ Missing host param - App Bridge will fail');
    }

    // Optional (clean URL after storing)
    if (host || shop) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
}
